import Grid from '@material-ui/core/Grid';
import React from 'react';
import { InputLabel } from '@material-ui/core';
import FormSection from '../../../components/atom/FormSection';
import { ReadOnlyField } from '../../../components/FormField';

function ContactBlock({ topLabel, phone, email, xs = 6 }) {
    if (!phone && !email) {
        return null;
    }
    return (
        <Grid item xs={xs}>
            <b>{topLabel}:</b>
            {phone && <br />}
            {phone ? phone : ''}
            {email && <br />}
            {email ? email : ''}
        </Grid>
    );
}

export default function BookingItemCompanySettings({ values }) {
    const anyContactInfo =
        values.activity?.company.contact_name ||
        values.activity?.company.contact_phone?.office ||
        values.activity?.company.contact_email?.office ||
        values.activity?.company.contact_phone?.reservation ||
        values.activity?.company.contact_email?.reservation ||
        values.activity?.company.contact_phone?.customer ||
        values.activity?.company.contact_email?.customer;

    return (
        <FormSection title="Company information">
            {anyContactInfo && (
                <>
                    <ContactBlock
                        topLabel="Contact name"
                        phone={values.activity?.company.contact_name}
                        email={''}
                    />
                    <ContactBlock
                        topLabel="Office"
                        phone={values.activity?.company.contact_phone?.office}
                        email={values.activity?.company.contact_email?.office}
                    />
                    <ContactBlock
                        topLabel="Reservation"
                        phone={values.activity?.company.contact_phone?.reservation}
                        email={values.activity?.company.contact_email?.reservation}
                    />
                    <ContactBlock
                        topLabel="Customer support"
                        phone={values.activity?.company.contact_phone?.customer}
                        email={values.activity?.company.contact_email?.customer}
                    />
                </>
            )}

            {values.activity?.extra_info.location && (
                <>
                    <Grid item xs={12}>
                        <InputLabel>Location</InputLabel>
                    </Grid>
                    <ReadOnlyField
                        label="State"
                        value={values.activity?.extra_info.location.state}
                        xs={6}
                    />
                    <ReadOnlyField
                        label="City"
                        value={values.activity?.extra_info.location.city}
                        xs={6}
                    />
                    <ReadOnlyField
                        label="Street"
                        value={values.activity?.extra_info.location.street}
                        xs={6}
                    />
                    <ReadOnlyField
                        label="Postal code"
                        value={values.activity?.extra_info.location.postalCode}
                        xs={6}
                    />
                </>
            )}
        </FormSection>
    );
}
